import { ApplicationModuleCode } from '@/domain/application-modules/application-module.interface';
import { ApplicationModulesService } from '@/domain/application-modules/application-modules.service';
import { ProfileProvider } from '@/providers/profile/profile.provider';
import { ACCESS_PROJECT_ADMINISTRATION } from '@/providers/rights.constants';
import { FeatureCode } from '@/utils/disabled-features/disabled-features.interface';
import { DisabledFeaturesService } from '@/utils/disabled-features/disabled-features.service';
import { inject, Injectable } from '@angular/core';
import { Router, type CanActivateChildFn, type CanActivateFn } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class IpmvpFeatureService {
    private _router = inject(Router);
    private _disabledFeaturesProvider = inject(DisabledFeaturesService);
    private _applicationModulesProvider = inject(ApplicationModulesService);
    private _profileProvider = inject(ProfileProvider);

    goToFeature() {
        this._router.navigate(['/', 'admin-ipmvp']);
    }

    async hasReadingFeatureAccess(): Promise<boolean> {
        if (this._disabledFeaturesProvider.isFeatureEnabled(FeatureCode.IPMVP_MODEL)) {
            const [hasInternalModuleAccess, hasIPMVPVisionModuleAccess] = await Promise.all([
                this._profileProvider.hasInternalModuleAccess(),
                this._applicationModulesProvider.hasModuleAccess(ApplicationModuleCode.IPMVP_VISION)
            ]);

            return (
                hasInternalModuleAccess ||
                (hasIPMVPVisionModuleAccess && this._profileProvider.hasFeatureAccess(ACCESS_PROJECT_ADMINISTRATION))
            );
        } else {
            return false;
        }
    }

    hasFeatureAccessR(): boolean {
        if (this._disabledFeaturesProvider.isFeatureEnabled(FeatureCode.IPMVP_MODEL)) {
            return (
                this._profileProvider.hasInternalModuleAccessR() ||
                (this._applicationModulesProvider.hasModuleAccessR(ApplicationModuleCode.IPMVP_VISION) &&
                    this._profileProvider.hasFeatureAccess(ACCESS_PROJECT_ADMINISTRATION))
            );
        } else {
            return false;
        }
    }

    hasEditingFeatureAccessR(): boolean {
        if (this._disabledFeaturesProvider.isFeatureEnabled(FeatureCode.IPMVP_MODEL)) {
            return (
                this._profileProvider.hasInternalModuleAccessR() ||
                (this.hasFeatureAccessR() && this._applicationModulesProvider.hasModuleAccessR(ApplicationModuleCode.IPMVP_EDITION))
            );
        } else {
            return false;
        }
    }
}
export const IpmvpGuard: CanActivateFn & CanActivateChildFn = async () => {
    const featureService = inject(IpmvpFeatureService);
    const hasFeatureAccess = await featureService.hasReadingFeatureAccess();

    if (!hasFeatureAccess) {
        return false;
    }
    return true;
};
